import { useState } from 'react'
import { url } from '@10000/common'
import { environment, useAuth, useInstance, useNotifications, useRequest, userMode, useView } from '@10000/react'
import { Box, Button, CenteredBox, Dialog, HoverTooltip, Icon } from '../../widgets'
import { ConfirmExit, usePracticeWheel } from '.'
import { query } from '../../../utilities.js'
import { isFree } from '../../../lookups'

const { view } = query()

export const Toolbar = ({ mobileOnly, small, onCloseMobile }) => {
  const request = useRequest('squiz')
  const { qrVisible, presenter, options: { kiosk, free, solo, guides } = {}, stage, analyticsGuidesCompleted: { yourData } = {} } = useView('squiz')

  const { subscription } = useView('tenant')
  const { id, region } = useInstance()
  const { notify } = useNotifications()
  const [confirmExit, setConfirmExit] = useState(false)
  const [openTools, setOpenTools] = useState(false)
  const { hide } = usePracticeWheel()

  const { user } = useAuth()
  const isSuper = user?.super && userMode() === 'super'

  const openDisplay = () => window.open(url.game('shivoo', id, { region, view: 'display' }))
  const toggleQr = () => request('qrToggled')
  const exit = goToAnalytics => {
    setConfirmExit(false)
    if(goToAnalytics) {
      hide()
      return request('analyticsStarted')
    } else {
      return request('squizExited')
    }
  }
  const openTestTools = () => window.open(url.tools.test('shivoo', id, { region }), 'test')
  const copyUrl = () => {
    try {
      navigator.clipboard.writeText(url.game('shivoo', id, { region }))
      setOpenTools(false)
      onCloseMobile?.()
      notify(`Participant URL copied to clipboard`, 'info')
    } catch {
      notify(`Couldn't copy to clipboard`)
    }
  }

  const completeGuide = !guides || yourData

  return ((presenter && (!view || (view === 'presenter' && isSuper))) &&
    <>
      <Box column gap={8} position="fixed" top={95} left={20} zIndex={99} className="desktop-only" id="toolbar" r={20}>
        {(!kiosk && !solo) &&
          <ToolbarButton icon="Landscape" onClick={openDisplay} toolTipText="Open presentation screen" />
        }
        {!solo && <>
          <ToolbarButton icon="QRIcon" background={qrVisible ? 'var(--red)' : 'white'} onClick={toggleQr} toolTipText="Toggle QR code" />
          <ToolbarButton icon="Link" onClick={copyUrl} toolTipText="Copy join link"/>
        </>}
        {!free &&
          <ToolbarButton icon="Exit" onClick={() => setConfirmExit(true)} toolTipText="Exit Squiz" />
        }
        {environment.development &&
          <ToolbarButton icon="Devices" onClick={openTestTools} toolTipText="Open test harness" />
        }

        <ConfirmExit
          open={confirmExit}
          onCancel={() => setConfirmExit(false)}
          onConfirm={exit}
        />

        {stage === 'analytics' &&
          <Box position="fixed" bottom={40} right={80} className="desktop-only">
            {(completeGuide && !isFree(subscription)) &&
              <Button onClick={() => setConfirmExit(true)}>
                Exit Squiz
              </Button>
            }
          </Box>
        }
      </Box>
      {(mobileOnly && !solo) &&
        <Box className="mobile-only">
          <ToolbarIconButton icon="Controls" size={small ? 39 : 58} iconSize={small ? 24 : 32} onClick={() => setOpenTools(true)}/>
        </Box>
      }
      <Dialog
        onClose={() => {
          setOpenTools(false)
          if(onCloseMobile) {
            onCloseMobile()
          }
        }}
        open={openTools}
        showControls={false}
        mobileBackground="white"
      >
        <Box column gap={16} fullWidth>
          <Button fullWidth onClick={copyUrl}>Copy join link</Button>
          {!free &&
            <Button fullWidth onClick={() => setConfirmExit(true)}>Exit Squiz</Button>
          }
        </Box>
      </Dialog>
    </>
  )
}

export const ToolbarButton = ({ icon, background, onClick, size, iconSize, toolTipText }) => (
  <HoverTooltip text={toolTipText} position="right">
    <ToolbarIconButton
      icon={icon}
      background={background}
      onClick={onClick}
      size={size}
      iconSize={iconSize}
    />
  </HoverTooltip>
)

export const ToolbarIconButton = ({ icon, background = 'white', onClick, size = 42, iconSize = 24 }) => (
  <CenteredBox
    size={size}
    r="50%"
    background={background}
    onClick={onClick}
    cursor="pointer"
  >
    <Icon
      fill="black"
      icon={icon}
      size={iconSize}
    />
  </CenteredBox>
)
